import api from 'api';

export const BATCH_RECIPE_ASYNC_ACTION_START = 'BATCH_RECIPE_ASYNC_ACTION_START';
export const BATCH_RECIPE_ASYNC_ACTION_ERROR = 'BATCH_RECIPE_ASYNC_ACTION_ERROR';
export const BATCH_RECIPE_ASYNC_UPDATE_ACTION_SUCCESS = 'BATCH_RECIPE_ASYNC_UPDATE_ACTION_SUCCESS';

// fire when only update partial data of the recipe
export const BATCH_RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS = 'BATCH_RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS';
export const BATCH_RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS = 'BATCH_RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS';
export const BATCH_RECIPE_ASYNC_RESTORE_ACTION_SUCCESS = 'BATCH_RECIPE_ASYNC_RESTORE_ACTION_SUCCESS';
export const BATCH_RECIPE_UPDATE_ACTION_SUCCESS = 'BATCH_RECIPE_UPDATE_ACTION_SUCCESS';
export const BATCH_RECIPE_RESET_STATE = 'BATCH_RECIPE_RESET_STATE';
export const BATCH_RECIPE_ASYNC_DELETE_ACTION_SUCCESS = 'BATCH_RECIPE_ASYNC_DELETE_ACTION_SUCCESS';
export const BATCH_RECIPE_ACTION_SUCCESS = 'BATCH_RECIPE_ACTION_SUCCESS';

function batchRecipeAsyncActionStart() {
  return {
    type: BATCH_RECIPE_ASYNC_ACTION_START,
  };
}

function batchRecipeAsyncActionError(error) {
  return {
    type: BATCH_RECIPE_ASYNC_ACTION_ERROR,
    error,
  };
}

function batchRecipeAsyncUpdateSuccess(data) {
  return {
    type: BATCH_RECIPE_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function batchRecipePartialAsyncUpdateSuccess(data) {
  return {
    type: BATCH_RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS,
    data,
  };
}

function batchRecipeAsyncArchiveSuccess() {
  return {
    type: BATCH_RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS,
  };
}

function batchRecipeAsyncRestoreSuccess() {
  return {
    type: BATCH_RECIPE_ASYNC_RESTORE_ACTION_SUCCESS,
  };
}

function batchRecipeAsyncDeleteSuccess() {
  return {
    type: BATCH_RECIPE_ASYNC_DELETE_ACTION_SUCCESS,
  };
}

function batchRecipeActionSuccess() {
  return {
    type: BATCH_RECIPE_ACTION_SUCCESS,
  };
}

export function updateRecipe(data) {
  return {
    type: BATCH_RECIPE_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetBatchRecipeState() {
  return {
    type: BATCH_RECIPE_RESET_STATE,
  };
}

// for Ingredients Batch Recipe
export function createBatchRecipeAsync(recipe) {
  return (dispatch, getState) => {
    dispatch(batchRecipeAsyncActionStart());
    return api.request('recipe', 'post', recipe, api.contentTypes.form)
    .then((data) => {
      dispatch(batchRecipeAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to create batch recipe'));
      throw (err);
    });
  };
}

export function updateBatchRecipeAsync(recipe) {
  return (dispatch, getState) => {
    dispatch(batchRecipeAsyncActionStart());
    return api.request('recipe', 'put', recipe, api.contentTypes.form)
    .then((data) => {
      dispatch(batchRecipeAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to update batch recipe'));
      throw (err);
    });
  };
}

// for Partially update Ingredients Batch Recipe
export function updatePartialBatchRecipeAsync(formData, recipe) {
  return (dispatch, getState) => {
    
    // update the value to store immediately
    const partialModifiedData = {
      recipeName: recipe.get('recipeName'),
      yield: recipe.get('yield'),
      yieldUnits: recipe.get('yieldUnits'),
      note: recipe.get('note'),
      prepTimeMinutes: recipe.get('prepTimeMinutes'),
      cookTimeMinutes: recipe.get('cookTimeMinutes'),
    };
    dispatch(batchRecipePartialAsyncUpdateSuccess(partialModifiedData));
    dispatch(batchRecipeAsyncActionStart());
    return api.request('recipe', 'put', formData, api.contentTypes.form)
    .then((data) => {
      const partialAffectedData = {
        costPerServing: data.costPerServing,
        costPerPortion: data.costPerPortion,
      };
      dispatch(batchRecipePartialAsyncUpdateSuccess(partialAffectedData));
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to update batch recipe'));
      throw (err);
    });
  };
}

export function getBatchRecipeAsync(id) {
  return (dispatch, getState) => {
    dispatch(batchRecipeAsyncActionStart());
    return api.request(`recipe/?recipeId=${ id }`, 'get')
    .then((data) => {
      dispatch(batchRecipeAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to get batch recipe'));
      throw (err);
    });
  };
}

export function updateBatchRecipeBatchLevel(recipe) {
  return (dispatch, getState) => {
    dispatch(batchRecipeAsyncActionStart());
    return api.request('recipe/batchLevel ', 'put', recipe)
    .then((data) => {
      dispatch(batchRecipeAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to update batch recipe batchLevel'));
      throw (err);
    });
  };
}

export function archiveBatchRecipeAsync(batchRecipeId) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/archive/${ batchRecipeId }`, 'post')
    .then((data) => {
      dispatch(batchRecipeAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to archive batch recipe'));
      throw (err);
    });
  };
}

export function restoreArchiveBatchRecipeAsync(batchRecipeId) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/restoreArchive/${ batchRecipeId }`, 'post')
    .then((data) => {
      dispatch(batchRecipeAsyncRestoreSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to restore batch recipe'));
      throw (err);
    });
  };
}

export function deleteBatchRecipeAsync(batchRecipeId) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/${ batchRecipeId }`, 'delete')
    .then((data) => {
      dispatch(batchRecipeAsyncDeleteSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to delete batch recipe'));
      throw (err);
    });
  };
}

export function moveToRecipe(recipeId) {
  return (dispatch, getState) => {
    dispatch(batchRecipeAsyncActionStart());
    return api.request(`recipe/moveToRegularRecipe/${recipeId}`, 'put')
    .then(() => {
      dispatch(batchRecipeActionSuccess());
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to move batch recipe to regular recipe'));
      throw (err);
    })
  }
}

export function duplicateBatchRecipeAsync(recipeId) {
  return (dispatch, getState) => {
    dispatch(batchRecipeAsyncActionStart());
    return api.request(`recipe/duplicate?id=${recipeId}`, 'post')
    .then((data) => {
      dispatch(batchRecipeActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipeAsyncActionError('Unable to Duplicate Recipes'));
      throw (err);
    })
  }
}
